import { createApi } from '@reduxjs/toolkit/query/react';
import { createBackendBaseQuery } from '../../utils/createAuthBaseQuery';
import { API_URLS } from '../../constants/apiUrl';

export interface ServiceConnectSearchResponse {
  serialNumber: string;
  motorNumber: string;
  modelName: string;
  productionDate: string;
}

export interface ServiceConnectSearchParams {
  serialNumber: string;
}

const BASE_URL = process.env.REACT_APP_MOTER_SERVICE_API_BASE_URL as string;

if (!BASE_URL) {
  throw new Error('REACT_APP_MOTER_SERVICE_API_BASE_URL environment variable is not set');
}

const baseQuery = createBackendBaseQuery(BASE_URL);

export const serviceConnectApiSlice = createApi({
  reducerPath: 'serviceConnectApi',
  baseQuery: baseQuery,
  tagTypes: ['ServiceConnect'],
  endpoints(builder) {
    return {
      searchBySerialNumber: builder.query<ServiceConnectSearchResponse, ServiceConnectSearchParams>({
        query: (params) => ({
          url: `${API_URLS.MOTOR_SERVICE.SERVICE_CONNECT}?serialNumber=${encodeURIComponent(params.serialNumber)}`,
          method: 'GET',
        }),
        providesTags: ['ServiceConnect'],
      }),
    };
  },
});

export const { useSearchBySerialNumberQuery, useLazySearchBySerialNumberQuery } = serviceConnectApiSlice;
